// extracted by mini-css-extract-plugin
export default {"container":"Container_container__yjEKR","narrowContainer":"Container_narrowContainer__hwBqU","wideContainer":"Container_wideContainer__nZNes"};